import {AxiosCall} from '../axios';
import {serializeQueryParams} from './PaymentHistoryService';

export type INotificationModuleType = 'appointment' | 'statement' | 'patient';

export const fetchNotificationBatchIds = ({
  clinic_group_id,
  clinic_id,
  params
}: {
  clinic_group_id: number | string;
  clinic_id: number | string;
  params: {
    type: INotificationModuleType;
    [index: string]: any;
  };
}): Promise<any> => {
  const queryParams = serializeQueryParams(params);
  return AxiosCall.get(
    `/clinic-group/${clinic_group_id}/clinic/${clinic_id}/reminder/notification-batch?${queryParams}`
  );
};

export const fetchNotificationHistory = ({
  clinic_group_id,
  clinic_id,
  params
}: {
  clinic_group_id: number | string;
  clinic_id: number | string;
  params: {
    type: INotificationModuleType;
    [index: string]: any;
  };
}): Promise<any> => {
  const queryParams = serializeQueryParams(params);
  return AxiosCall.get(
    `/clinic-group/${clinic_group_id}/clinic/${clinic_id}/reminder/notification-history?${queryParams}`
  );
};

export const fetchNotificationFailedReasons = ({
  clinic_group_id,
  clinic_id,
  params
}: {
  clinic_group_id: number | string;
  clinic_id: number | string;
  params: {
    type: INotificationModuleType;
    [index: string]: any;
  };
}) => {
  const queryParams = serializeQueryParams(params);
  return AxiosCall.get(
    `/clinic-group/${clinic_group_id}/clinic/${clinic_id}/reminder/notification-failed-reasons?${queryParams}`
  );
};

export const downloadFailedNotificationsFile = ({
  clinic_group_id,
  clinic_id,
  params
}: {
  clinic_group_id: number | string;
  clinic_id: number | string;
  params: {
    type: INotificationModuleType;
    [index: string]: any;
  };
}) => {
  const queryParams = serializeQueryParams(params);
  return AxiosCall.get(`/clinic-group/${clinic_group_id}/clinic/${clinic_id}/reminder/notification-history/download?${queryParams}`);
}